import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LCElement } from './lc-forms.interface';
export class LCElementComponent {
/**
 * @return {?}
 */
get toSet() {
        return this.element && this.element.classes && this.element.classes.wrapper ? this.element.classes.wrapper : '';
    }
/**
 * @param {?} value
 * @return {?}
 */
set info(value) {
        this.element = value.element;
        this.form = value.form;
        this.settings = value.settings;
        this.classes = value.classes;

        if (this.element.type === 'checkbox') {
            this.element.value = !this.element.value ? [] : this.element.value;
            this.checkboxIsRequired = this.element.validation && this.element.validation[0].type === 'required';
        }

        if (this.classes.errors) {
            if (!this.element.classes.error) { this.element.classes.error = this.classes.errors; } else {
                this.element.classes.error = this.element.classes.error.concat(this.classes.errors);
            }
        }
    }

     valueChange: EventEmitter<any> = new EventEmitter();

    element: LCElement;
    form: FormGroup;
    classes: any;
private checkboxIsRequired = false;
private settings: any;
/**
 * @return {?}
 */
get showErrorMsg() {
        return this.settings.errorOnDirty ?
            !this.form.controls[this.element.key].valid && !this.form.controls[this.element.key].dirty :
            !this.form.controls[this.element.key].valid;
    }
/**
 * @return {?}
 */
errors() {
        if (this.element.validation && !this.form.controls[this.element.key].valid) {
            const /** @type {?} */ temp: any = [], /** @type {?} */
                errors = this.form.controls[this.element.key].errors, /** @type {?} */
                errorKeys = Object.keys(errors);

            if (this.settings.singleErrorMessage) {
                    temp.push(this._setError(errorKeys[errorKeys.length - 1], errors));
                } else { errorKeys.forEach(a => temp.push(this._setError(a, errors))); }

            return temp;
        }
    }
/**
 * @param {?} option
 * @return {?}
 */
setRadio(option) {
        this.form.controls[this.element.key].setValue(option.value);
        this.onValueChange(option.value);
    }
/**
 * @param {?} option
 * @return {?}
 */
setCheckbox(option) {
        const /** @type {?} */ index = this.element.value.indexOf(option.value);

        if (index !== -1) { this.element.value.splice(index, 1); } else { this.element.value.push(option.value); }

        this.form.controls[this.element.key].setValue(this.element.value);
        this.onValueChange(this.element.value);
    }
/**
 * @return {?}
 */
chackboxValueChange() {
        if (this.checkboxIsRequired) {
            if (this.element.value.length === 1) {
                this.element.options.find(a => a.value === this.element.value[0]).disabled = true;
            } else { this.element.options.forEach(a => a.disabled = false); }
        }
    }
/**
 * @param {?} event
 * @return {?}
 */
onValueChange(event) {
        if (this.element.emitChanges !== false) { this.valueChange.emit({ [this.element.key]: event }); }
    }
/**
 * @param {?} option
 * @return {?}
 */
isSelectActive(option) { return this.element.value.find(a => a === option.value) ? true : false; }
/**
 * @param {?} item
 * @param {?} errors
 * @return {?}
 */
private _setError(item, errors) {
        let /** @type {?} */ errorMsg: string = this.element.validation.find(a => a.type.toLowerCase() === item).message;
        const /** @type {?} */ tag: string = this.element.label || this.element.key;

        if (!errorMsg) {
            switch (item) {
                // Set error messages
                case 'required':
                    errorMsg = `${tag} is required.`;
                    break;

                case 'minlength':
                    errorMsg = `${tag} has to be at least ${errors[item].requiredLength} characters long.`;
                    break;

                case 'maxlength':
                    errorMsg = `${tag} can't be longer then ${errors[item].requiredLength} characters.`;
                    break;

                case 'pattern':
                    errorMsg = `${tag} must match this pattern: ${errors[item].requiredPattern}.`;
                    break;

                case 'match':
                    errorMsg = `${tag} must match the ${errors[item].mustMatchField} field.`;
                    break;
            }
        }
        return errorMsg;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    // tslint:disable-next-line:component-selector
    selector: 'lc-element',
    template: `
      <div [formGroup]="form" [ngClass]="element.classes?.group">
          <label *ngIf="element.label"
                 [ngClass]="element.classes?.label"
                 [attr.for]="element.key">
              {{element.label}}
          </label>
          <div [ngSwitch]="element.type">
              <select *ngSwitchCase="'dropdown'"
                      [formControlName]="element.key"
                      (ngModelChange)="onValueChange($event)"
                      [ngClass]="element.classes?.element"
                      [id]="element.key">
                  <option *ngFor="let o of element.options" [value]="o.value">{{o.name ? o.name : o.value}}</option>
              </select>

              <div *ngSwitchCase="'checkbox'" [ngClass]="element.classes?.element">
                  <div class="checkbox" *ngFor="let o of element.options">
                      <input [type]="element.type"
                             [formControlName]="element.key"
                             [name]="element.key"
                             [value]="o.value"
                             [checked]="isSelectActive(o)"
                             (change)="chackboxValueChange()"
                             (click)="setCheckbox(o)">
                      <span>{{o.name ? o.name : o.value}}</span>
                  </div>
              </div>

              <textarea *ngSwitchCase="'textarea'"
                  [formControlName]="element.key"
                  (ngModelChange)="onValueChange($event)"
                  [id]="element.key"
                  [attr.placeholder]="element.placeholder"
                  [attr.rows]="element.rows"
                  [ngClass]="element.classes?.element"></textarea>

              <div *ngSwitchCase="'radio'" [ngClass]="element.classes?.element">
                  <div class="radio" *ngFor="let o of element.options">
                      <input [type]="element.type"
                             [formControlName]="element.key"
                             [name]="element.key"
                             [value]="o.value"
                             [checked]="element.value === o.value"
                             (click)="setRadio(o)">
                      <span>{{o.name ? o.name : o.value}}</span>
                  </div>
              </div>

              <input *ngSwitchDefault
                     [formControlName]="element.key"
                     [attr.placeholder]="element.placeholder"
                     [type]="element.type"
                     (ngModelChange)="onValueChange($event)"
                     [ngClass]="element.classes?.element"
                     [id]="element.key">
          </div>

          <div *ngIf="settings.showValidation" [hidden]="showErrorMsg">
              <span *ngFor="let e of errors()" [ngClass]="element.classes?.error">{{e}}</span>
          </div>
      </div>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'toSet': [{ type: HostBinding, args: ['class', ] },],
'info': [{ type: Input },],
'valueChange': [{ type: Output },],
};
}

function LCElementComponent_tsickle_Closure_declarations() {
/** @type {?} */
LCElementComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LCElementComponent.ctorParameters;
/** @type {?} */
LCElementComponent.propDecorators;
/** @type {?} */
LCElementComponent.prototype.valueChange;
/** @type {?} */
LCElementComponent.prototype.element;
/** @type {?} */
LCElementComponent.prototype.form;
/** @type {?} */
LCElementComponent.prototype.classes;
/** @type {?} */
LCElementComponent.prototype.checkboxIsRequired;
/** @type {?} */
LCElementComponent.prototype.settings;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
